import React from 'react';
import { EventConditions } from '../../../BuilderFields';
import { useCohortRowContext } from '../CohortRowContext';

const PerformedCohort = () => {
  const { rowMeta } = useCohortRowContext();

  return (
    <EventConditions
      rowMeta={rowMeta}
      label={'Event(s)'}
      showLabelPerCondition
    />
  );
};

export default PerformedCohort;
